import styled from 'styled-components';
import { mediaQuery } from '../../common/styles/styleUtil';

export const HighlightWrapper = styled.div`
  @media (${mediaQuery.tablet}) {
    padding: 0 16px;
  }
`;

export const HighlightTitle = styled.h2`
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
  font-weight: 500;
  color: #333f48;

  @media (${mediaQuery.mobile}) {
    font-size: 20px;
    line-height: 26px;
  }
`;

export const HighlightList = styled.div`
  @media (${mediaQuery.tablet}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 24px;
    row-gap: 16px;
  }

  @media (${mediaQuery.mobile}) {
    grid-template-columns: 1fr;
  }
`;
